(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6205],{

/***/ 16832:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photos",
      function () {
        return __webpack_require__(29705);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ModalUnstyledDemo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95629);
/* harmony import */ var src_components_Photos__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23677);



function ModalUnstyledDemo() {
    let Basic = window.localStorage.getItem("Basic");
    Basic = Basic == null || Basic == 0 ? true : false;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Photos__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            getDirectories: src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getAlbumSummary */ .A0,
            getPhotos: src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getAlbumDetail */ .Ao
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,1033,8914,3368,1675,5378,6886,607,2697,6138,3677,9774,2888,179], function() { return __webpack_exec__(16832); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);